var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"variant":_vm.variant,"title":_vm.longStatus}},[_vm._v(" "+_vm._s(_vm.short ? _vm.shortStatus : _vm.longStatus)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }